
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateLocationDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    lindasUid: new FormControl<string | undefined>(undefined, [Validators.maxLength(64)]),
    zipcode: new FormControl<number | undefined>(undefined),
    canton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    communitySponsorship: new FormControl<string | undefined>(undefined),
    businessunitId: new FormControl<number | undefined>(undefined),
    bfsNumber: new FormControl<number | undefined>(undefined),
    communityName: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    language: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
})
;
}
      